import { useBulkAppointmentUpload } from "@/app/shared/appointments/bulk-upload.hooks";
import { bulkUploadVendorAppointments } from "./bulk-upload.api";

export function useBulkUpload() {
  return useBulkAppointmentUpload(bulkUploadVendorAppointments);
}
